import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import commonMessages from 'common/messages/messages';
import { useGetRole } from 'api/role.api';
import { DialogComponent, LoadingBackdrop } from 'common/components';
import ViewRoleModalContent from 'modules/permissions/components/ViewRoleModal/ViewRoleModalContent';

interface IViewRoleModal {
  title: string;
  roleId: string;
  onClose: () => void;
}

const ViewRoleModal: FC<IViewRoleModal> = ({ title, roleId, onClose }) => {
  const { data: role, isLoading } = useGetRole(roleId);
  const intl = useIntl();

  return (
    <DialogComponent
      title={title}
      submitBtnTitle={intl.formatMessage(commonMessages.closeBtn)}
      size="sm"
      onClose={onClose}
      disableFullScreenBehavior
      submitBtn={false}
      cancelBtnTitle={intl.formatMessage(commonMessages.closeBtn)}
      isOpen
    >
      <LoadingBackdrop isLoading={isLoading} />
      {role ? <ViewRoleModalContent role={role} /> : null}
    </DialogComponent>
  );
};

export default ViewRoleModal;
